import _ from 'underscore';

const safeConsole = (function() {
  let safeConsoleInstance = null;

  function createInstance() {
    const isConsoleValid = _.isObject(window.console) && globals.NODE_ENV !== 'production';
    const safeConsole = {
      log: function(arg0, ...args) {
        if (isConsoleValid) {
          if (args && args.length) {
            console.log(arg0, ...args);
          } else {
            console.log(arg0);
          }
        }
      },
      info: function(arg0, ...args) {
        if (isConsoleValid) {
          if (args && args.length) {
            console.log(arg0, ...args);
          } else {
            console.log(arg0);
          }
        }
      },
      error: function(arg0, ...args) {
        if (isConsoleValid) {
          if (args && args.length) {
            console.error(arg0, ...args);
          } else {
            console.error(arg0);
          }
        }
      },
    };
    return safeConsole;
  }

  if (!safeConsoleInstance) {
    safeConsoleInstance = createInstance();
  }
  return safeConsoleInstance;
})();

export default safeConsole;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/util/ConsoleUtils.js